module.exports = __webpack_public_path__ + "img/fig26.85f19413.jpg";